import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const friendLinks = [
  { name: "哔哩哔哩", url: "https://gg911.asia" },
  { name: "优酷视频", url: "https://www.youku.com" },
  { name: "爱奇艺", url: "https://www.iqiyi.com" },
  { name: "腾讯视频", url: "https://v.qq.com" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-primary-950 text-background-100">
      <div className="mx-auto grid w-full gap-8 px-4 py-12 md:px-6 lg:grid-cols-4">
        <div className="lg:col-span-1">
          <div className="mb-3 flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-play-circle-fill text-2xl"></i>
            </span>
            <span className="font-heading text-lg font-bold text-background-50">啪啪视频</span>
          </div>
          <p className="text-sm leading-relaxed text-background-300">
            啪啪视频是面向大众的高清在线视频分享平台，汇聚娱乐、生活、教育等多类别视频内容，让你随时随地发现并分享精彩。
          </p>
        </div>

        <div>
          <h3 className="mb-3 font-heading text-sm font-semibold text-background-50">视频分类</h3>
          <ul className="flex flex-wrap gap-x-4 gap-y-2 text-sm lg:flex-col">
            {categories.map((cat) => (
              <li key={cat.slug}>
                <Link to={`/category/${cat.slug}`} className="text-background-300 transition-colors duration-200 hover:text-background-50">
                  {cat.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="mb-3 font-heading text-sm font-semibold text-background-50">快速导航</h3>
          <ul className="flex flex-col gap-2 text-sm">
            <li>
              <Link to="/" className="text-background-300 transition-colors duration-200 hover:text-background-50">
                首页
              </Link>
            </li>
            <li>
              <Link to="/search" className="text-background-300 transition-colors duration-200 hover:text-background-50">
                视频搜索
              </Link>
            </li>
            <li>
              <Link to="/about" className="text-background-300 transition-colors duration-200 hover:text-background-50">
                关于我们
              </Link>
            </li>
            <li>
              <Link to="/contact" className="text-background-300 transition-colors duration-200 hover:text-background-50">
                联系我们
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="mb-3 font-heading text-sm font-semibold text-background-50">联系我们</h3>
          <ul className="flex flex-col gap-2 text-sm text-background-300">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line"></i>
              support@papavideo.com
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-phone-line"></i>
              400-880-1234
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-map-pin-line mt-0.5"></i>
              北京市朝阳区视频大道 88 号
            </li>
          </ul>
          <div className="mt-4">
            <h4 className="mb-2 text-xs font-semibold uppercase tracking-wide text-background-400">友情链接</h4>
            <div className="flex flex-wrap gap-x-4 gap-y-1 text-sm">
              {friendLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-background-300 transition-colors duration-200 hover:text-background-50"
                >
                  {link.name}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex w-full flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-background-400 sm:flex-row md:px-6">
          <p>© 2026 啪啪视频 papavideo.com 版权所有 · 本站视频内容均为演示数据</p>
          <p className="flex flex-wrap items-center gap-3">
            <span>京ICP备2026000000号</span>
            <span className="hidden sm:inline">|</span>
            <span>高清视频 从这里开始</span>
          </p>
        </div>
      </div>
    </footer>
  );
}